<script>
import appConfig from "@/app.config";

import { notificationMethods } from "@/state/helpers";
import { mapActions } from "vuex";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },
  created() {
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      // this.clearNotification();
    }

  },
 
  methods: {
    ...mapActions(['permissionsUser']),
    clearNotification: notificationMethods.clear
    
  },
  // componentDidMount() {
  //   const detectBrowserLanguage = localStorage.getItem('dinflow-lang') == null ? require('detect-browser-language') : localStorage.getItem('dinflow-lang')
  //   this.setState({ userLanguage: detectBrowserLanguage() })
  // },
 
  // render() {
  //   const { userLanguage } = localStorage.getItem('dinflow-lang') == null ? this.state : localStorage.getItem('dinflow-lang')
 
  //   return <h1>{userLanguage}</h1>
  // }
  
};
</script>

<template>
  <div id="app">
    <RouterView /> 
  </div>
</template>
